import { normalizedState } from '@/common/lib/entity-module';
import { BASE_URL, SERVER_LIST } from '@/common/constants';

/**
 *
 * @param {string | null | undefined} server
 * @param {string} label
 */
export const getServerLabel = (server, label) => {
  if (!server) return label;
  return `${label}_${server}`;
};

export const STATE_KEY_LIST = Object.freeze([
  'spList',
  'ownerList',
  'officeList',
  'officeInfoList',
  'shopList',
  'applyList',
  'staffList',
]);

export const STATE_OPTIONS_LIST = Object.freeze([
  ['officeOrder', 1],
  ['showInvalid', 1],
  ['serverSetting', getDefaultServerSetting],
]);

export const getDefaultServerSetting = () => ({
  id: '',
  userSearchMode: 0,
});

export const getInitState = (useOtherServer) => {
  const ret = {};
  for (const key of STATE_KEY_LIST) {
    ret[key] = { ...normalizedState };
  }
  for (const [key, def] of STATE_OPTIONS_LIST) {
    const defVal = typeof def === 'function' ? def() : def;
    ret[key] = defVal;
  }
  if (useOtherServer) {
    for (const server in SERVER_LIST) {
      for (const key of STATE_KEY_LIST) {
        ret[getServerLabel(server, key)] = { ...normalizedState };
      }
      for (const [key, def] of STATE_OPTIONS_LIST) {
        const defVal = typeof def === 'function' ? def() : def;
        ret[getServerLabel(server, key)] = defVal;
      }
    }
  }
  return ret;
};

export const getBaseUrl = (server) => {
  if (!server)
    return BASE_URL;

  let baseUrl = SERVER_LIST[server];
  if (!baseUrl)
    return BASE_URL;

  if (!baseUrl.startsWith('http'))
    baseUrl  = `${location.protocol}//${baseUrl}`;
  if (baseUrl.endsWith('/'))
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

  return baseUrl;
};

export const getApiEntry = (server) => {
  const baseUrl = getBaseUrl(server);
  if (!baseUrl.endsWith('/'))
    return baseUrl + '/ajax';
  return baseUrl + 'ajax';
};

/**
 * 
 * @param {object} stateApp 
 * @param {string | undefined} server 
 * @returns 
 */
export const getStateAppOfServer = (stateApp, server) => {
  if (!server)
    return stateApp;
  const ret = { __server__: server };
  
  for (const key of STATE_KEY_LIST) {
    ret[key] = stateApp[getServerLabel(server, key)] ?? { ...normalizedState };
  }
  for (const [key, def] of STATE_OPTIONS_LIST) {
    ret[key] = stateApp[getServerLabel(server, key)] = (
      typeof def === 'function' ? def() : def
    );
  }
  return ret;
};

/**
 * 
 * @param {object} state 
 * @param {string | undefined} server 
 * @returns 
 */
export const getStateOfServer = (state, server) => ({
  ...state ?? {},
  app: getStateAppOfServer(state?.app ?? {}, server)
});

/**
 * 
 * @param {string} [host] 
 * @returns 
 */
export const useServerList = (host) => ({
  serverList: [undefined, ...Object.keys(SERVER_LIST)],
  showServer: Object.keys(SERVER_LIST).length !== 0,
  defaultServerName: {
    'cti1.fuzoku-fan.jp': 'cti1',
    'cti2.fuzoku-fan.jp': 'cti2',
    'cti3795.fuzoku-fan.jp': 'cti3795',
  }[host || location.host],
});

/**
 * 指摘したサーバーにいるのか確認
 * @param {string} server cti3795 や cti1 とか（「cti」の部分必須）
 * @returns 
 */
export const isServer = (server) => {
  const sub = location?.host?.split('.')?.[0] ?? '';
  return server === sub;
};